import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const ChatOutline = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12.8334 13.8889H19.1667M12.8334 18.1111H16M15.9696 25.5C10.7229 25.5 6.5 21.1722 6.5 15.952C6.5 10.7318 10.7533 6.5 16 6.5C21.2467 6.5 25.5 10.7318 25.5 15.952C25.5 17.8845 24.9171 19.6815 23.9167 21.1786L25.5 25.5H15.9696Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper strokeWidth={1} {...props} variant="outline" viewBox="0 0 32 32">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { ChatOutline };